var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccuracy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.084,
    height: 46.05,
    viewBox: "0 0 46.084 46.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#362a63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19183e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.917,
    y1: -1.982,
    x2: -0.598,
    y2: 5.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#ffb147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3.913,
    y1: -4.873,
    x2: -0.637,
    y2: 2.476,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.954,
    y1: 0.128,
    x2: 0.024,
    y2: 0.937,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2.906,
    y1: 0.198,
    x2: -5.416,
    y2: 1.514,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 6.444,
    y1: -2.339,
    x2: -2.015,
    y2: 1.614,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.87,
    y1: -0.233,
    x2: 0.035,
    y2: 1.114,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b99e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.046,
    y1: 1.269,
    x2: 0.845,
    y2: -0.193,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3e0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66107",
    "data-name": "Path 66107",
    d: "M78.42,133.742,55.553,156.575a.926.926,0,1,1-1.309-1.309l22.867-22.833A3.442,3.442,0,0,1,78.42,133.742Z",
    transform: "translate(-49.387 -115.383)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66106",
    "data-name": "Path 66106",
    d: "M32.923,263.764a9.567,9.567,0,0,1-4-.113.288.288,0,0,0-.278.088c-.467.523-2.285,2.57-3.491,4.051a.1.1,0,0,0,.106.155,3.115,3.115,0,0,1,3.161.539,3.115,3.115,0,0,1,.539,3.161.1.1,0,0,0,.155.106c1.481-1.206,3.527-3.024,4.051-3.491a.288.288,0,0,0,.088-.278,9.573,9.573,0,0,1-.113-4,.186.186,0,0,0-.221-.221Z",
    transform: "translate(-25.135 -225.723)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66108",
    "data-name": "Path 66108",
    d: "M127.823,30.366,115.8,34.547l-10.942-4.129Z",
    transform: "translate(-92.175 -29.55)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66109",
    "data-name": "Path 66109",
    d: "M82,133.682l-.983,1.861-6.663,1.9,4.5-4.113Z",
    transform: "translate(-66.524 -116.141)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66110",
    "data-name": "Path 66110",
    d: "M117.247,25.236l-37.379,13,10.942-.31-.464,2.632,18.849-7.268-7.268,18.849,2.632-.464-.31,10.942Z",
    transform: "translate(-71.162 -25.236)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66111",
    "data-name": "Path 66111",
    d: "M287.638,90.848l-4.181,12.026,4.129,10.942Z",
    transform: "translate(-242.37 -80.412)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66112",
    "data-name": "Path 66112",
    d: "M184.679,217.681l-1.861.983-1.9,6.663,4.113-4.5Z",
    transform: "translate(-156.136 -187.072)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66113",
    "data-name": "Path 66113",
    d: "M195.185,108.457a44.844,44.844,0,0,1,3.4-7.572s-3.292,3.586-6.73,3.178c-.275.087-.55.166-.822.235a.177.177,0,0,0-.083.3l1.308,1.308,1.309,1.309,1.32,1.32a.177.177,0,0,0,.294-.074Z",
    transform: "translate(-164.537 -88.853)",
    fill: "url(#linear-gradient-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66114",
    "data-name": "Path 66114",
    d: "M199.984,104.586l3.656-3.7a34.393,34.393,0,0,1-6.73,3.177,2.928,2.928,0,0,0,.67.718A1.838,1.838,0,0,0,199.984,104.586Z",
    transform: "translate(-169.588 -88.853)",
    fill: "url(#linear-gradient-9)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracy);
export default __webpack_public_path__ + "static/media/accuracy.473ffe49426770b12ee2e40323ab9c24.svg";
export { ForwardRef as ReactComponent };